var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-3"},[_c('h6',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('ul',{staticClass:"p-0"},_vm._l((_vm.documents),function(document,index){return _c('li',{key:`document_${index}`},[_c('a',{attrs:{"href":document.uri,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.documentName(document))+"\n      ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }